<template>
  <div>
    <multi-selection-list
      caption="Queue Names"
      :items="queueNames"
      @add="addQueue"
      @remove="removeQueue"
    />
    <div style="margin-top: 10px" class="flex justify-end">
      <input
        class="btn"
        type="button"
        style="margin-right: 5px"
        value="All"
        @click="selectAll"
      />
      <input class="btn" type="button" value="Clear" @click="clear" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
  },

  computed: {
    queueNames() {
      return this.$diamond.allowedQueues.map((x) => ({
        name: x.value,
        selected: this.items.includes(x.key),
      }));
    },
  },

  methods: {
    addQueue(name) {
      var index = this.$diamond.allowedQueues.findIndex((x) => x.value == name);
      this.$store.getters.queueArgs.addQueueNumber(
        this.$diamond.allowedQueues[index].key
      );
      this.items.push(this.$diamond.allowedQueues[index].key);
      this.$emit("selected", name);
    },

    removeQueue(name) {
      var index = this.$diamond.allowedQueues.findIndex((x) => x.value == name);
      var selectedIndex = this.items.indexOf(this.$diamond.allowedQueues[index].key);
      this.$store.getters.queueArgs.removeQueueNumber(
        this.$diamond.allowedQueues[index].key
      );
      if (index !== -1) {
        this.items.splice(selectedIndex, 1);
        this.$emit("removed", name);
      }
    },

    clear() {
      let i = this.items.length;
      while (i--) {
        var index = this.$diamond.allowedQueues.findIndex((z) => z.key == this.items[i]);
        this.$store.getters.queueArgs.removeQueueNumber(
          this.$diamond.allowedQueues[index].key
        );
        this.items.splice(i, 1);
        this.$emit("removed", this.items[i]);
      }
    },

    selectAll() {
      var states = this.queueNames
        .map((x) => x.name)
        .filter((x) => !this.items.includes(x));

      for (let i = 0; i < states.length; i++) {
        var index = this.$diamond.allowedQueues.findIndex(
          (x) => x.value == states[i]
        );
        this.addQueue(this.$diamond.allowedQueues[index].value);
      }
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}

.justify-end {
  justify-content: flex-end;
}

.btn {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #0186c9;
  border: 0;
  padding: 6px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
</style>